import store from '../store';


export const absoluteUrl = path => {
  if (typeof window === 'undefined' || (path && path.startsWith('http'))) {
    return path;
  } else {
    let baseUrl = `${window.location.protocol}//${window.location.host}`;
    if (window.navigator.userAgent === 'PrerenderCrawler') {
      const projectSettings = store.getState().project;
      baseUrl = projectSettings.siteUrl;
    }
    return `${baseUrl}${path || ''}`;
  }
};

export const uniqify = (str, arr, i = 1) => {
  if (arr.indexOf(str) === -1) {
    return str;
  } else {
    const uniq = `${str}-${i}`;
    return arr.indexOf(uniq) === -1 ? uniq : uniqify(str, arr, i + 1);
  }
};



// WEBPACK FOOTER //
// ./src/utils/url.js